
import AbstractModel from "@/models/AbstractModel";

/**
 *  VarianteQueryResult sind Ergebnisse aus
 *  KombiRepository.findVariants
 *
 */
class VarianteQueryResult extends AbstractModel {
	get defaultData() {
		return {
			className: 'VarianteQueryResult',
			selected: false,	// Zur Zeit aktiv / ausgewählt? 
			selectable: false,	// In der Auswahl für User als Option auswählbar? 
			conflicts: {}		// Falls selectable == false : Begründung 
		}
	}

	get hasConflicts() {
		return this.numConflicts > 0;
	}

	get numConflicts() {
		return Object.keys( this.conflicts ).length;
	}
}

export default VarianteQueryResult;



// WEBPACK FOOTER //
// ./src/models/VarianteQueryResult.js